import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider as OidcProvider } from 'react-oidc-context';
// Suite fonts — self-hosted via @fontsource (CSP-safe: font-src 'self'; NO
// Google-Fonts <link>/@import, which a strict CSP would block). DM Sans is the
// body/number default; Playfair Display = .ri-display titles + the wordmark;
// DM Serif Display = italic subtitles.
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import '@fontsource/dm-sans/800.css';
import '@fontsource/playfair-display/700.css';
import '@fontsource/playfair-display/800.css';
import '@fontsource/playfair-display/900.css';
import '@fontsource/playfair-display/900-italic.css';
import '@fontsource/dm-serif-display/400.css';
import '@fontsource/dm-serif-display/400-italic.css';
// Suite tokens + helpers + sidebar + scroll-lock (Tailwind v4, preflight OFF).
// Imported before App.css so existing component CSS keeps the upper hand.
import './renewal-theme/theme.css';
import App from './App';
import './App.css';
import { oidcConfig } from './auth/oidc-config.js';
import { initializeCsrfToken } from './api/client.js';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Plant the `_csrf` cookie before the user can trigger any mutation, so the
// first state-changing request of a session doesn't fail with "CSRF token not
// found". Fire-and-forget: apiRequest also self-heals a missing token, so a
// slow/failed init here is non-fatal. (See api/client.ts, csrf.middleware.ts.)
void initializeCsrfToken();

createRoot(rootElement).render(
  <StrictMode>
    <OidcProvider {...oidcConfig}>
      <App />
    </OidcProvider>
  </StrictMode>
);
